import $ from 'jquery'

export class BannerTop {
  constructor() {
    this.$bannerTop = $('.banner-top')
    this.$bannerTopContent = $('.banner-top-content')

    if (this.$bannerTop.length === 0) {
      return
    }

    setTimeout(this.fixBannerTopHeight.bind(this), 150)
    $(window).on('resize', this.fixBannerTopHeight.bind(this))
  }

  fixBannerTopHeight() {
    const height = this.$bannerTopContent.outerHeight(true)
    this.$bannerTop.css({'height': height + 'px'})
    // The fixed header offsets itself below the banner via --header-top-pos
    // (see critical/components/header.scss), which reads this variable.
    document.documentElement.style.setProperty('--banner-top-height', height + 'px')
  }
}
